import { Component, ViewChild, ChangeDetectionStrategy, Optional, Inject, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { PershingTranslationService } from '@pershing/pershing-core';
import { Router, ActivatedRoute } from '@angular/router';
import { PershingHttpUtil } from '@pershing/pershing-core';

@Component({
    selector: 'login-marketing',
    templateUrl: './login-marketing.component.html',
    styleUrls: ['./login-marketing.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginMarketingComponent implements  AfterViewInit {
    slideNo = 0;
    withAnim = true;
    resetAnim = true;
    selectedIndex: number;
    transform: number;
    community: string = 'pas';
    themeType: string = 'conservative';
    header: string = '';
    locale: string;

    public imageUrl1: String;
    public imageUrl2: String;
    public imageUrl3: String;
    public imageUrl4: String;

    private urlPath: String;
    dasfLoginEnabled: boolean = false;
    public sliderArray = new Array();
    public carouselItems: any[];
    @ViewChild('myCarousel') myCarousel: NguCarousel;
    carouselConfig: NguCarouselConfig = {
        grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
        load: 3,
        interval: { timing: 10000, initialDelay: 1000 },
        point: {
            visible: true,
            hideOnSingleSlide: true
        },
        loop: true,
        touch: true,
        velocity: 0.1
    };

    constructor(
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        @Optional() @Inject('AppSettings') appSettings: any,
        private translationService: PershingTranslationService
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-mod', 'node_modules/@pershing/nxi-ng-mod/lib');
        this.header = 'HEADERTITLE';
        this.selectedIndex = 0;
        this.transform = 100;
        if (!!appSettings) {
            this.themeType = appSettings.ibdConfigMap.themeType;
            this.community = appSettings.ibdConfigMap.community;
            let parsemap = appSettings.ibdConfigMap;
            if (appSettings.locale) {
                this.locale = appSettings.locale;
            }
            if ((parsemap.generic || parsemap.isSiteBuilderSite) && parsemap.community !== 'equipt') {
                this.urlPath = parsemap.cdnURL + '/pershing.netxinvestor.brands/' + appSettings.nxiBrandVersion + '/themes/' + parsemap.themeName + '/images/';
            } else {
                this.urlPath = parsemap.cdnURL + '/pershing.netxinvestor.brands/' + appSettings.nxiBrandVersion + '/themes/' + parsemap.themeName +
                    '/brand/' + parsemap.cssBrand + '/images/';
            }
            if (appSettings.dasfLoginEnabled) {
                this.dasfLoginEnabled = appSettings.dasfLoginEnabled;
            }
            if (this.dasfLoginEnabled) {
                let argsmap = {};
                if (this.route.snapshot.queryParams) {
                    argsmap = this.route.snapshot.queryParams;
                    argsmap = JSON.parse(JSON.stringify(argsmap));
                    console.log('argsmap' + argsmap);
                }
                this.router.navigateByUrl('/nxi/welcome?' + PershingHttpUtil.getQueryStringFromJsonObject(argsmap));
                return;
            }
            this.carouselItems = [{
                'url': this.urlPath + '/slideshow_img1_Access.jpg',
                'articleid': 'lmimage1_content'
            }];
            if (appSettings.ibdConfigMap.LMImage2Enable) {
                this.carouselItems.push({
                    'url': this.urlPath + '/slideshow_img2_Organize.jpg',
                    'articleid': 'lmimage2_content'
                });
            }
            if (appSettings.ibdConfigMap.LMImage3Enable) {
                this.carouselItems.push({
                    'url': this.urlPath + '/slideshow_img3_Statement.jpg',
                    'articleid': 'lmimage3_content'
                });
            }
            if (appSettings.ibdConfigMap.LMImage4Enable) {
                this.carouselItems.push({
                    'url': this.urlPath + '/slideshow_img4_Simplify.jpg',
                    'articleid': 'lmimage4_content'
                });
            }
            if (appSettings.ibdConfigMap.LMImage5Enable) {
                this.carouselItems.push({
                    'url': this.urlPath + '/slideshow_img5_Custom.jpg',
                    'articleid': 'lmimage5_content'
                });
            }
        }
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();
    }

    reset() {
        this.myCarousel.reset(!this.resetAnim);
    }

    moveTo(slide) {
        this.myCarousel.moveTo(slide, !this.withAnim);
    }
}
